import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CartaCreateSelectTypePage } from '../carta-create/carta-create-select-type/carta-create-select-type';
import { CartaCreateCustomizeViewPage } from '../carta-view/carta-create-customize-view';
import { CartaServices } from '../services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TutorialCartaPage } from '../../help/tutorials/tutorial-carta/tutorial-carta';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-list',
  templateUrl: 'carta-list.html',
})
export class CartaListPage {

  cartas: any = [];
  cartas_tmp: any = [];
  show_tutorial: boolean = false;
  searchbar_text = '';
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public cartaServices: CartaServices,
    public translate: TranslateService) {

    //Tutorial Carta
    if (this.globals.restaurant.license == 'free') {
      this.show_tutorial = true;
      this.navCtrl.push(TutorialCartaPage);
    }

  }

  async ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-cartas')
    });
    //If per no mostrar el loader sobre la pagina del tutorial
    if (!this.show_tutorial) {
      loadingPopup.present();
    }
    this.cartas = await this.cartaServices.getCartas(this.globals.restaurant_uid);
    this.cartas_tmp = this.cartas;
    this.filter(this.searchbar_text);
    this.cartaServices.carta_lang = this.globals.restaurant.lang;
    this.globals.GAtrackView('Cartas', 'Cartas - List', this.globals.restaurant.email, 'View', 'List cartas', 'Cartas', '');
    loadingPopup.dismiss();
  }

  openCartaCreate() {
    if (this.cartaServices.total_cartas >= this.globals.checkLimitsByLicense('menus', 'max_menus') && this.globals.checkLimitsByLicense('menus', 'max_menus') != -1) { //Si limit menus
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {//Si no limit menus
      this.navCtrl.push(CartaCreateSelectTypePage);
    }
  }

  openCartaView(carta) {
    if (carta._active) {
      this.navCtrl.push(CartaCreateCustomizeViewPage, {
        carta_uid: carta.UID,
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  ionViewWillLeave() {
    this.cartaServices.no_cartas = true;
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.openCartaView(event.row);
    }
  }

  filter(value) {
    var _return = [];
    this.searchbar_text = value;

    if (value != undefined && value.length > 0) {
      this.cartas_tmp.forEach(carta => {
        if (carta.name_es != undefined && carta.name_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        } else if (carta.name_en != undefined && carta.name_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        } else if (carta.name_ca != undefined && carta.name_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        } else if (carta.name_de != undefined && carta.name_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        } else if (carta.name_fr != undefined && carta.name_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        } else if (carta.name_it != undefined && carta.name_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(carta);
        }
      });
      this.cartas = _return;
      this.cartas = [...this.cartas];
    } else {
      this.cartas = this.cartas_tmp;
      this.cartas = [...this.cartas];
    }
  }

  getRowClass(row) {
    return {
      'not-active': row._active === false
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-list/carta-list.ts